import recombee from 'recombee-js-api-client'; // no TS defs
import { APP_CONFIG } from '../../global/base';
import cookies from '../../utils/storage/cookies';

type RecombeeClientType = typeof recombee.ApiClient;

interface RecombeeConfigType {
    client: RecombeeClientType | undefined;
    userId: string;
}

const recombeeConfig: RecombeeConfigType = {
    client: undefined,
    userId: cookies.read('CurrentContact')
}

export function recombeeClientInit() {
    try {
        recombeeConfig.client = new recombee.ApiClient(APP_CONFIG.recombee.database, APP_CONFIG.recombee.key);
    }
    catch {
        console.log('errors while starting recombee ocurred');
    }
}

export function recombeeAddToCart(productGuid:string, amount:number, recommId?: string | null) {
    // Recombee AddCartAddition requires amount in [0, 2^63-1]; cart decrement passes negative Count
    if (amount <= 0) {
        return;
    }
    if(recombee && recombeeConfig.client) {
        if (!recombeeConfig.userId) {
            recombeeConfig.userId = cookies.read('CurrentContact');
        }
        try {
            recombeeConfig.client.send(new recombee.AddCartAddition(recombeeConfig.userId, productGuid, {
                // optional parameters:
                'timestamp': new Date(),
                'cascadeCreate':true,
                'amount': amount,
                'recommId': recommId,
              }), console.log('recombee data sent', recommId));
        }
        catch {
            console.log('something went wrong with adding to cart in recombee');
        }
    }
    else {
        recombeeClientInit();
    }
}

export function recombeeAddSale(productGuid: string, amount: number, timestamp: Date, recommId: string) {
    if(recombee && recombeeConfig.client) {
        if (!recombeeConfig.userId) {
            recombeeConfig.userId = cookies.read('CurrentContact');
        }
        try {
            recombeeConfig.client.send(
                ( typeof recommId === 'undefined' || recommId === null ) ?
                    new recombee.AddPurchase(recombeeConfig.userId, productGuid, {
                        // optional parameters:
                        'timestamp':timestamp,
                        'cascadeCreate': true,
                        'amount': amount
                    })
                :
                    new recombee.AddPurchase(recombeeConfig.userId, productGuid, {
                    // optional parameters:
                    'timestamp':timestamp,
                    'cascadeCreate': true,
                    'amount': amount,
                    'recommId': recommId
              }), console.log('recombee sales sent'));
        }
        catch {
            console.log('something went wrong with adding sales in recombee');
        }
    }
    else {
        recombeeClientInit();
    }
}
